/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react';
import { ErrorToastText, ToastNature } from '../../common/types';

import { getUserEmail } from '../../flows/email';
import Toast from '../Toast';

export const userInfo = () => {
  const [email, setEmail] = useState('User');
  const [isMigratedToAuthz3, setIsMigratedToAuthz3] = useState(false);

  const userEmail = React.useMemo(
    () => ({
      getUserEmailInfo: async () => {
        const response: any = await getUserEmail();
        try {
          setEmail(response.email);
          setIsMigratedToAuthz3(response.isMigratedToAuthz3);
        } catch (error) {
            Toast.notify({
              description: ErrorToastText.EMAIL,
              nature: ToastNature.ERROR,
            });
            if (email !== 'User') {
              setEmail('User');
            }
        }
          // .then((response: any) => {
          //   setLoading(false);
          //   setEmail(response);
          // })
          // .catch((error) => {
          //   Toast.notify({
          //     description: ErrorToastText.EMAIL,
          //     nature: ToastNature.ERROR,
          //   });
          //   if (email !== 'User') {
          //     setEmail('User');
          //   }
          // });
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return { email, userEmail, isMigratedToAuthz3 };
};
